// extracted by mini-css-extract-plugin
export var textInput = "_ie-0";